import { PiDogFill } from "react-icons/pi";
import { IoLogoOctocat } from "react-icons/io5";
import { GiParrotHead } from "react-icons/gi";
import { GiTigerHead } from "react-icons/gi";

import { GiKoala } from "react-icons/gi";

export const IconsRow = (props) => {
  const pet = props.pet;

  return (
    <div className="room-icons-row">
      {pet === 1 && <PiDogFill />}
      {pet === 2 && <IoLogoOctocat />}
      {pet === 3 && <GiParrotHead />}
      {pet === 4 && <GiTigerHead />}
      {pet === 5 && <GiKoala />}
    </div>
  );
};
